import * as React from "react";
const SvgDatabaseServer11 = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 3.754V20.256H22.13V3.754H12ZM3.38 5.252H20.62v6H3.38v-3Zm2.996 2.246v1.506H8.717V7.498H7.545zm4.684 0v1.506h6.566V7.498h-3.283Zm-7.68 5.26H20.62v5.99H3.38v-2.994Zm2.996 2.236v1.508H8.717v-1.508H7.545zm4.684 0v1.508h6.566v-1.508h-3.283z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgDatabaseServer11;
